module.exports = __webpack_public_path__ + "img/icon85.dd9ba15d.png";